// extracted by mini-css-extract-plugin
export default {"content":"styles_content__bIIlk","canvas":"styles_canvas__Cudx6"};